import { decodeEdifyJwtPayload } from './jwtPayload.ts'

export type ReduxAccessPayload = {
  access: string
  refresh: string
  expire: number
  name: string
}

export const buildReduxAccessPayloadFromAccessToken = (
  access_token: string
): ReduxAccessPayload => {
  const payload = decodeEdifyJwtPayload(access_token)
  const expSec = typeof payload?.exp === 'number' ? payload.exp : undefined
  const now = Math.floor(Date.now() / 1000)
  const expire =
    expSec !== undefined ? Math.max(0, expSec - now) : 0
  const name =
    typeof payload?.name === 'string'
      ? payload.name
      : typeof payload?.user_name === 'string'
        ? payload.user_name
        : ''
  return {
    access: `Bearer ${access_token}`,
    refresh: '',
    expire,
    name,
  }
}
